import React, { createContext, useContext, useState } from 'react';

const UIDesignContext = createContext(null);

export const UIDesignProvider = ({ children }) => {
    const [viewMode, setViewMode] = useState('all'); // 'all' | 'mobile' | 'tablet' | 'desktop'
    const [showGrid, setShowGrid] = useState(true);
    const [syncScroll, setSyncScroll] = useState(false);

    return (
        <UIDesignContext.Provider value={{
            viewMode,
            setViewMode,
            showGrid,
            setShowGrid,
            syncScroll,
            setSyncScroll
        }}>
            {children}
        </UIDesignContext.Provider>
    );
};

export const useUIDesign = () => {
    const context = useContext(UIDesignContext);
    if (!context) {
        // Return default values if not in a UIDesignProvider
        return {
            viewMode: 'all',
            setViewMode: () => { },
            showGrid: true,
            setShowGrid: () => { },
            syncScroll: false,
            setSyncScroll: () => { }
        };
    }
    return context;
};

export default UIDesignContext;
